import { render, staticRenderFns } from "./ManualPay.vue?vue&type=template&id=644d1302&"
import script from "./ManualPay.vue?vue&type=script&lang=js&"
export * from "./ManualPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports